import { focusEvents } from "@/mocks/campus";
import SectionHead from "./SectionHead";
import Reveal from "./Reveal";

function fmt(n: number) {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}w`;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}k`;
  return `${n}`;
}

export default function FocusEvents() {
  return (
    <section id="focus" className="scroll-mt-24">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <Reveal>
          <SectionHead
            eyebrow="焦点事件"
            title="校园吃瓜头条 · 值得深挖的事件"
            desc="不止是标题，每一条焦点都附上完整的来龙去脉。围观之余，也看懂事情为什么会火。"
          />
        </Reveal>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          {focusEvents.map((ev, i) => (
            <Reveal key={ev.id} delay={i * 90}>
              <article className="group flex h-full flex-col overflow-hidden rounded-3xl bg-background-50 ring-1 ring-background-200 transition-shadow hover:shadow-soft">
                <div className="relative aspect-[16/11] overflow-hidden">
                  <img
                    src={ev.image}
                    alt={ev.title}
                    title={`校园瓜田 ${ev.title}`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-xs font-semibold text-primary-700 backdrop-blur whitespace-nowrap">
                    {ev.category}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5 md:p-6">
                  <h4 className="text-base font-bold leading-snug text-foreground-950 md:text-lg">{ev.title}</h4>
                  <p className="mt-2.5 flex-1 text-sm leading-relaxed text-foreground-600">{ev.excerpt}</p>
                  <div className="mt-4 flex flex-wrap items-center gap-1.5">
                    {ev.tags.map((t) => (
                      <span key={t} className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-800 whitespace-nowrap">
                        {t}
                      </span>
                    ))}
                  </div>
                  <div className="mt-4 flex items-center justify-between border-t border-background-200/80 pt-3.5 text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1"><i className="ri-eye-line" /> {fmt(ev.views)} 围观</span>
                    <span className="inline-flex items-center gap-1"><i className="ri-chat-3-line" /> {fmt(ev.discuss)} 讨论</span>
                    <span className="inline-flex items-center gap-1 whitespace-nowrap"><i className="ri-time-line" /> {ev.date}</span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}